import * as _ from 'lodash';

const pickOffer = data =>
  _.omit(data, ['productLogoUrl', 'photoUrl']);

export default pickOffer;
